import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { numericFormatter } from 'react-number-format';

import { Paper, Container, Grid, Box, Typography } from '@material-ui/core';
import Loader from 'components/Loader';
import PeriodType from '../PeriodType';
import PeriodRange from '../PeriodRange';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';

import { useStyles } from '../styles';

const ResumeValues = ({ isMobile, value }) => {
  return(
    <Grid container justify="center">
      <Grid item>
        <Typography variant={isMobile ? "h6" : "h4"} color="primary">
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
}

const Resume = ({ isLoading }) => {
  const classes = useStyles();

  const { width } = useWindowDimensions();
  const isMobile = width < 960;

  const establishmentId = useSelector(state => state.businessInfo.establishmentId);
  const { singleEstablishmentResume, resume, type } = useSelector(state => state.cashFlow);

  return(
    <Container className={classes.container}>
      <Box mt={2}>
        <Box pt={0} pb={5}>
          <Grid
            container
            spacing={2}
            justify="flex-end"
            alignItems="center"
          >
            {isMobile && (
              <Grid item xs={12} alignContent="flex-end">
                <Grid container justify="flex-end" direction="row">
                  <PeriodType
                    fullWidth
                    active={type}
                  />
                </Grid>
              </Grid>
            )}
            <Grid item xs={12} alignContent="flex-end">
              <Grid container justify="flex-end" direction="row">
                <PeriodRange fullWidth={isMobile} />
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={6} md={4}>
            <Paper align="center" className={classes.paperSuccess}>
              <Loader isLoading={isLoading}>
                <Typography paragraph color="primary">
                  Entradas
                </Typography>
                <ResumeValues
                  isMobile={isMobile}
                  value={
                    !establishmentId
                      ? numericFormatter(resume?.receipts?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })
                      : numericFormatter(singleEstablishmentResume?.receipts?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })
                  }
                />
              </Loader>
            </Paper>
          </Grid>
          <Grid item xs={6} md={4}>
            <Paper align="center" className={classes.paperError}>
              <Loader isLoading={isLoading}>
                <Typography paragraph color="primary">
                  Saídas
                </Typography>
                <ResumeValues
                  isMobile={isMobile}
                  value={
                    !establishmentId
                      ? numericFormatter(resume?.payments?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })
                      : numericFormatter(singleEstablishmentResume?.payments?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })
                  }
                />
              </Loader>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper align="center" className={classes.paperPrimary}>
              <Loader isLoading={isLoading}>
                <Typography paragraph color="primary">
                  Total
                </Typography>
                <ResumeValues
                  isMobile={isMobile}
                  value={
                    !establishmentId
                      ? numericFormatter(resume?.balance?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })
                      : numericFormatter(singleEstablishmentResume?.balance?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })
                  }
                />
              </Loader>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

ResumeValues.propTypes = {
  value: PropTypes.string.isRequired
};

Resume.propTypes = {
  resume: PropTypes.arrayOf(
    PropTypes.shape({
      receipts: PropTypes.string,
      payments: PropTypes.string,
      balance: PropTypes.string
    })
  ).isRequired
};

export default Resume;